import React, {
    ChangeEvent,
    Dispatch,
    SetStateAction,
    useRef,
    useState,
} from "react";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ListarEmpreendimentosController } from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../Form";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { MoneyReaisFieldMask } from "../../../../Validations/InputMasks";
import { IRepasseDadosBI } from "../../../../Interfaces/Repasse/RepasseDadosBI/RepasseDadosBIInterface";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { InserirRepasseDadosBIController } from "../../../../Controllers/Repasse/RepasseDadosBI/RepasseDadosBIController";
import { AlertConfirmation } from "../../../../Tools/SweetAlerts";

interface IModal {
    SetShow: Dispatch<SetStateAction<boolean>>;
}

export default function RepasseDadosBI({ SetShow }: IModal) {
    const FormMethods = useForm();
    const selectInputRef = useRef<any>();
    const [lstEmpreendimentosSelect, setlstEmpreendimentosSelect] =
        useState<{ label: string; value: number }[]>();

    const { execute: InserirDadosRepasseBI } = useAsyncCallback(
        InserirRepasseDadosBIController
    );

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };
    const { value: lstEmpreendimentosOptions } = useAsyncEffect(
        () =>
            ListarEmpreendimentosController().then((res) => {
                return res?.map((e) => ({
                    label: e.DS_EMPREENDIMENTO,
                    value: e.ID_EMPREENDIMENTO,
                }));
            }),
        []
    );
    function hadleFilterFormSubmit(formData: any) {
        const resquest = {
            ...formData,
            lstEmpreendimentos: lstEmpreendimentosSelect?.map(
                (res) => res.value
            ),
        };
        InserirDadosRepasseBI(resquest).then((response) => {
            AlertConfirmation(response.message, "", undefined, {
                cancelButtonText: false,
                confirmButtonText: "Ok",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    SetShow(false);
                }
            });
        });
    }
    function geradorMascaraFinanceira(inputName: keyof IRepasseDadosBI) {
        return (e: ChangeEvent<HTMLInputElement>) => {
            const mask = MoneyReaisFieldMask(e);
            FormMethods.setValue(inputName, mask);
        };
    }

    const filterOptons: IRepasseDadosBI = {
        NR_SICAQ_APROVADO: 0,
        NR_SICAQ_CONDICIONADO: 0,
        NR_ERRO_RESTRICAO: 0,
        NR_DOCUMENTOS_PENDENTES: 0,
        NR_EM_ANALISE_AGENCIA: 0,
        NR_SICAQ_REPROVADO: 0,
        NR_UHS_BLOQUEADAS: 0,
        VL_BLOQUEADO: 0.0,
        VL_BLOQUEADO_SEMANA_ANTERIOR: 0.0,
        NR_TOTAL_PERMUTAS: 0.0,
        NR_TOTAL_UNIDADES: 0,
    };

    return (
        <div>
            <FormProvider {...FormMethods}>
                <UnForm
                    handleSubmit={hadleFilterFormSubmit}
                    className="form-group row"
                    usingContext
                >
                    <div className="col-12 mt-3">
                        <label>Empreendimento</label>
                        <Select
                            name="ID_EMPREENDIMENTO"
                            ref={selectInputRef}
                            options={lstEmpreendimentosOptions}
                            value={lstEmpreendimentosSelect}
                            isClearable
                            isMulti
                            onChange={(e) => {
                                setlstEmpreendimentosSelect(
                                    e.map((value) => ({
                                        label: value.label,
                                        value: value.value,
                                    }))
                                );
                            }}
                            components={{
                                DropdownIndicator: () => null,
                                IndicatorSeparator: () => null,
                            }}
                            styles={customStyles}
                            placeholder={""}
                            noOptionsMessage={() => "Sem opções"}
                        />
                    </div>
                    <div className="col-3 mt-3">
                        <label>Nº SICAQ Aprovado</label>
                        <UnForm.Input
                            className="form-control"
                            type="number"
                            name="NR_SICAQ_APROVADO"
                            defaultValue={filterOptons.NR_SICAQ_APROVADO}
                        />
                    </div>
                    <div className="col-3 mt-3">
                        <label>Nº SICAQ Condicionado</label>
                        <UnForm.Input
                            className="form-control"
                            type="number"
                            name="NR_SICAQ_CONDICIONADO"
                            defaultValue={filterOptons.NR_SICAQ_CONDICIONADO}
                        />
                    </div>
                    <div className="col-3 mt-3">
                        <label>Nº SICAQ Reprovado</label>
                        <UnForm.Input
                            className="form-control"
                            type="number"
                            name="NR_SICAQ_REPROVADO"
                            defaultValue={filterOptons.NR_SICAQ_REPROVADO}
                        />
                    </div>
                    <div className="col-3 mt-3">
                        <label>Nº Erros Restrição</label>
                        <UnForm.Input
                            className="form-control"
                            type="number"
                            name="NR_ERRO_RESTRICAO"
                            defaultValue={filterOptons.NR_ERRO_RESTRICAO}
                        />
                    </div>
                    <div className="col-3 mt-3">
                        <label>Nº Doc. Pendentes</label>
                        <UnForm.Input
                            className="form-control"
                            type="number"
                            name="NR_DOCUMENTOS_PENDENTES"
                            defaultValue={filterOptons.NR_DOCUMENTOS_PENDENTES}
                        />
                    </div>
                    <div className="col-3 mt-3">
                        <label>Nº em Analise Agencia</label>
                        <UnForm.Input
                            className="form-control"
                            type="number"
                            name="NR_EM_ANALISE_AGENCIA"
                            defaultValue={filterOptons.NR_EM_ANALISE_AGENCIA}
                        />
                    </div>
                    <div className="col-3 mt-3">
                        <label>UHS Bloqueadas</label>
                        <UnForm.Input
                            className="form-control"
                            type="number"
                            name="NR_UHS_BLOQUEADAS"
                            defaultValue={filterOptons.NR_UHS_BLOQUEADAS}
                        />
                    </div>
                    <div className="col-3 mt-3">
                        <label>Total Unidades</label>
                        <UnForm.Input
                            className="form-control"
                            type="number"
                            name="NR_TOTAL_UNIDADES"
                            defaultValue={filterOptons.NR_TOTAL_UNIDADES}
                        />
                    </div>
                    <div className="col-4 mt-3">
                        <label>Nº Total Permutas</label>
                        <UnForm.Input
                            className="form-control"
                            type="number"
                            name="NR_TOTAL_PERMUTAS"
                            defaultValue={filterOptons.NR_TOTAL_PERMUTAS}
                        />
                    </div>
                    <div className="col-4 mt-3">
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Valor Bloqueado"
                            name="VL_BLOQUEADO"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    return Number(
                                        MoneyReaisFieldMask.unMask(v)
                                    );
                                },
                            }}
                            onChange={geradorMascaraFinanceira("VL_BLOQUEADO")}
                            defaultValue={filterOptons.VL_BLOQUEADO}
                        ></UnForm.Input>
                    </div>
                    <div className="col-4 mt-3">
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Valor Bloqueado Semana Anterior"
                            name="VL_BLOQUEADO_SEMANA_ANTERIOR"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    return Number(
                                        MoneyReaisFieldMask.unMask(v)
                                    );
                                },
                            }}
                            onChange={geradorMascaraFinanceira(
                                "VL_BLOQUEADO_SEMANA_ANTERIOR"
                            )}
                            defaultValue={
                                filterOptons.VL_BLOQUEADO_SEMANA_ANTERIOR
                            }
                        ></UnForm.Input>
                    </div>

                    <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                        <button
                            type="submit"
                            className="btn btn-block btn-outline-dark mt-2"
                        >
                            <FontAwesomeIcon icon={faSave} className="mr-2" />
                            Salvar
                        </button>
                    </div>
                </UnForm>
            </FormProvider>
        </div>
    );
}
